// Plan de découpage d'un fichier, compte tenu de ce qui est déjà sur le serveur.
// Renvoie [{offset, length, chunkIndex, totalChunks}].
//
// La reprise ne dépend pas d'un alignement de `tmpSize` sur `chunkSize` : c'est
// `offset` qui fait foi côté serveur (Element::uploadFile vérifie la taille du
// .tmp avant d'appendre, et tronque quand l'offset vaut 0). Deux clients aux
// tailles de chunk différentes peuvent donc reprendre le même .tmp, ce dont le
// mobile a besoin — 8 Mo là où le web utilise 200 Mo.
//
// Fonction pure, sans dépendance à File/Blob : testable seule et partagée telle
// quelle par les deux fronts.
export function planChunks(fileSize, tmpSize, chunkSize){
    // .tmp plus gros que le fichier : il est corrompu. On repart de zéro, ce qui
    // est sûr puisque l'offset 0 recrée le .tmp au lieu de le compléter.
    const start = (tmpSize > 0 && tmpSize <= fileSize) ? tmpSize : 0;
    const sent = Math.ceil(start / chunkSize);
    const chunks = [];
    for(let offset = start; offset < fileSize; offset += chunkSize){
        chunks.push({ offset : offset, length : Math.min(chunkSize, fileSize - offset) });
    }
    // .tmp déjà complet mais jamais renommé (réponse perdue sur le dernier
    // chunk) : un chunk vide suffit à déclencher le rename côté serveur.
    if(chunks.length === 0){
        chunks.push({ offset : start, length : 0 });
    }
    const totalChunks = sent + chunks.length;
    return chunks.map((chunk, i) => ({
        offset : chunk.offset,
        length : chunk.length,
        chunkIndex : sent + i,
        totalChunks : totalChunks
    }));
}
